import React, { Component } from "react";
import { Navbar } from "react-bootstrap";
import defaultLogo from "assets/img/zabin-logo.jpg";
import HeaderLinks from "./HeaderLinks.jsx";
import $ from "jquery";

class Header extends Component {
    constructor(props) {
        super(props);
        this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
        // this.showCanvasMenu = this.showCanvasMenu.bind(this);
        this.getAlert = this.getAlert.bind(this);
        this.state = {
            sidebarExists: true
        };
    }
    getAlert() {
        alert("getAlert from Child");
    }

    mobileSidebarToggle(e) {
        if (this.state.sidebarExists === true) {
            this.setState({
                sidebarExists: true
            });
        }
      }

      setSticky = (isOpen) => {
          if ($(".theme_table").hasClass("stickyHeader")) {
              $(".stickyTarget").width($(".stickyHeader").outerWidth());
              let rowCount = 0;
              $(".stickyHeader th").each(function () {
                  $(".stickyTarget th:eq(" + rowCount + ")").width($(this).width());
                  rowCount++;
              });

              isOpen ?
              $(".stickyTarget").css("left", ($(".stickyHeader").offset().left - 45))
              :
              $(".stickyTarget").css("left", "50px")
          }
      }

      componentDidUpdate(prevProps, prevState, snapshot){
        let that = this;
        if(prevProps.canvasMenuToggle !== this.props.canvasMenuToggle){
          setTimeout(function () {
            that.setSticky(that.props.canvasMenuToggle);
          }, that.props.canvasMenuToggle ? 500 : 100)
        }
      }

      componentDidMount(){
        this.props.canvasMenuToggle ?
        this.setSticky(this.props.canvasMenuToggle)
        :
        null
      }

  render() {
    return (
      <Navbar className="CustomHeader" fluid>
        <Navbar.Header>
          <Navbar.Link href="/Admin/dashboard">
            <img src={defaultLogo} height="60" alt="Zabin Logo"/>
          </Navbar.Link> 
          
          {/* <Navbar.Link className="sideNavToggle" onClick={this.props.showCanvasMenu} >
            <OverlayTrigger placement="right" overlay={
              <Tooltip id="homeMenu">{this.props.canvasMenuToggle ? "Close Menu" : "Open Menu"}</Tooltip>
              }>
              <div className={this.props.canvasMenuToggle ? "nav-icon closed" : "nav-icon"}>
                <div></div>
              </div>
            </OverlayTrigger>
          </Navbar.Link>  */}
          
          
        <Navbar.Toggle onClick={this.props.toggleMenu} />
        </Navbar.Header>
        <Navbar.Collapse>
          <HeaderLinks />
        </Navbar.Collapse>
      </Navbar>
    );
  }
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Admin/Header/Header.jsx